import { Record } from "immutable";
import BaseStore from "./BaseStore";
import { ActionTypes } from "../constants/AppConstants";


const State = new Record({
    isStepFreeEnabled: false,
    isSeatAvailabilityEnabled: false,
    isJourneySupportModalOpen: false,
});

class JourneySupportStore extends BaseStore {

    getInitialState () {
        return new State();
    }

    toggleStepFree () {
        this.setState(this.state.set('isStepFreeEnabled', !this.state.get('isStepFreeEnabled')));
    }

    toggleSeatAvailability () {
        this.setState(this.state.set('isSeatAvailabilityEnabled', !this.state.get('isSeatAvailabilityEnabled')));
    }

    toggleJourneySupportModal () {
        this.setState(this.state.set('isJourneySupportModalOpen', !this.state.get('isJourneySupportModalOpen')));
    }

    getJourneySupportModalStatus () {
        return this.state.get('isJourneySupportModalOpen');
    }

    getActionHandlers () {
        return {
            [ActionTypes.TOGGLE_STEP_FREE]: this.toggleStepFree,
            [ActionTypes.TOGGLE_SEAT_AVAILABILITY]: this.toggleSeatAvailability,
            [ActionTypes.TOGGLE_JOURNEY_SUPPORT_MODAL]: this.toggleJourneySupportModal,
        };
    }
}

export default new JourneySupportStore;



// WEBPACK FOOTER //
// ./src/stores/JourneySupportStore.js